<template>
    <div>
        <h5 class="heading-1 mb-4 mt-4">
            <span>SERVIÇOS</span>
        </h5>
        <b-alert show variant="warning" v-if="contrato.tipoEspecial">
            <h5>Atenção</h5>
            <p>
                Esse contrato requer documento(s) comprobatório(s) anexado(s) ao
                serviço, que este possa ser enviado para análise.
            </p>
        </b-alert>
        <app-tabela
            idTabela="tblRequisicaoComprometimentos"
            :itens="requisicaoComprometimentos"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="valor" slot-scope="data">{{
                data.valor | currency
            }}</template>
            <template slot="acoes" slot-scope="data">
                <comprometimento-anexos
                    :comprometimento="data"
                    :dataServico="dataServico"
                    :mostrarBtnInserir="mostrarBtnInserir(data)"
                    :mostrarBtnExcluir="mostrarBtnExcluir(data)"
                    @obter-atualizacao="$emit('obter-requisicao-atualizada')"
                ></comprometimento-anexos>
                <comprometimento-enviar-para-analise
                    :contrato="contrato"
                    :comprometimento="data"
                    :dataServico="dataServico"
                    @obter-atualizacao="$emit('obter-requisicao-atualizada')"
                >
                </comprometimento-enviar-para-analise>
                <comprometimento-aprovadores
                    :comprometimento="data"
                    :dataServico="dataServico"
                >
                </comprometimento-aprovadores>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import ComprometimentoAnexos from './ComprometimentoAnexos'
import ComprometimentoEnviarParaAnalise from './ComprometimentoEnviarParaAnalise'
import ComprometimentoAprovadores from './ComprometimentoAprovadores'
import { comprometimentoStatus } from './ComprometimentoStatus'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        requisicao: {
            type: Object,
            default: () => {}
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            erros: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'idComprometimento',
                    label: 'Id',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dataEmissao',
                    label: 'Data de Emissão',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'dataMovimento',
                    label: 'Data do Movimento',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap text-center',
                    type: 'date'
                },
                {
                    key: 'historico',
                    label: 'Histórico',
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'idRm',
                    label: 'ID RM',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    type: 'status'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'qtdAnexos',
                    label: 'Qtd. Anexos'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-nowrap text-center'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        mostrarBtnInserir(comprometimento) {
            return (
                (comprometimento.status == comprometimentoStatus.EM_ABERTO ||
                    comprometimento.status ==
                        comprometimentoStatus.REPROVADA) &&
                this.$temAcessoView('FORN-CONTRATOS-00')
            )
        },

        mostrarBtnExcluir(comprometimento) {
            return (
                (comprometimento.status == comprometimentoStatus.EM_ABERTO ||
                    comprometimento.status ==
                        comprometimentoStatus.REPROVADA) &&
                this.$temAcessoView('FORN-CONTRATOS-00')
            )
        }
    },

    created() {},

    computed: {
        requisicaoComprometimentos() {
            return this.requisicao.comprometimentos
        }
    },

    watch: {},

    components: {
        ComprometimentoAnexos,
        ComprometimentoEnviarParaAnalise,
        ComprometimentoAprovadores
    }
}
</script>
